export const CloseIcon = ({
  selected,
  disabled,
  className,
  ...props
}: React.ComponentProps<"svg"> & {
  selected?: boolean;
  disabled?: boolean;
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-selected={selected ? "true" : undefined}
    data-disabled={disabled ? "true" : undefined}
    className={`cursor-pointer rounded-[4px] p-0.5 border border-transparent text-[var(--neutral-default)] hover:bg-[var(--neutral-tonal)] hover:text-[var(--neutral-on-tonal)] active:text-[var(--neutral-click)] data-[selected=true]:bg-[var(--neutral-tonal)] data-[selected=true]:text-[var(--neutral-on-tonal)] data-[selected=true]:border-[var(--neutral-on-tonal)] disabled:bg-[var(--neutral-disabled)] disabled:text-[var(--neutral-on-disabled)] disabled:cursor-not-allowed ${className || ""}`}
    role="img"
    aria-label="Close"
    data-testid="modal-close-icon"
    {...props}
  >
    <path
      d="M3.18364 4.06668C2.93879 3.82183 2.93879 3.42589 3.18364 3.18364C3.4285 2.94139 3.82443 2.93879 4.06668 3.18364L8 7.11696L11.9333 3.18364C12.1782 2.93879 12.5741 2.93879 12.8164 3.18364C13.0586 3.4285 13.0612 3.82443 12.8164 4.06668L8.88304 8L12.8164 11.9333C13.0612 12.1782 13.0612 12.5741 12.8164 12.8164C12.5715 13.0586 12.1756 13.0612 11.9333 12.8164L8 8.88304L4.06668 12.8164C3.82183 13.0612 3.42589 13.0612 3.18364 12.8164C2.94139 12.5715 2.93879 12.1756 3.18364 11.9333L7.11696 8L3.18364 4.06668Z"
      fill="currentColor"
    />
  </svg>
);
